import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import Cyclist from './components/pages/cyclist';
import About from './components/pages/about';
import Frontpage from './components/pages/frontpage';
import Companies from './components/pages/companies';
import Member from './components/pages/member';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header className="App-header">
          <Header />   
        </header>
        
        <main>
          <Routes>
            <Route path="/" element={<Frontpage />} />
            <Route path="/um" element={<About />} />
            <Route path="/felog" element={<Companies />} />
            <Route path="/sukklarir" element={<Cyclist />} />
            <Route path="/limir" element={<Member />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
